"use client"

import { create } from "zustand"
import type { BooruPost } from "@/lib/booru-api"
import { postToBountyContent, type BountySelectedContent } from "@/lib/bounty-content-selection-store"

export interface CommissionSelectionTarget {
  id: string
  name: string
  avatar?: string
}

interface CommissionContentSelectionState {
  active: boolean
  target: CommissionSelectionTarget | null
  selectedContent: BountySelectedContent | null
  start: (target: CommissionSelectionTarget) => void
  cancel: () => void
  selectPost: (post: BooruPost) => BountySelectedContent | null
  consumeSelected: () => { target: CommissionSelectionTarget; content: BountySelectedContent } | null
}

export const useCommissionContentSelectionStore = create<CommissionContentSelectionState>((set, get) => ({
  active: false,
  target: null,
  selectedContent: null,
  start: (target) => set({ active: true, target, selectedContent: null }),
  cancel: () => set({ active: false, target: null, selectedContent: null }),
  selectPost: (post) => {
    const content = postToBountyContent(post)
    if (!content) return null
    set({ active: false, selectedContent: content })
    return content
  },
  consumeSelected: () => {
    const { target, selectedContent } = get()
    if (!target || !selectedContent) return null
    set({ target: null, selectedContent: null })
    return { target, content: selectedContent }
  },
}))
